import { animate, state, style, transition, trigger } from "@angular/animations";


export const flyInOut = trigger( 'flyInOut', [
	state( 'in', style( { transform: 'translateX(0)' } ) ),
	transition( 'void => *', [
		style( { transform: 'translateX(100%)' } ),
		animate( 300 ),
	]),
	transition( '* => void', [
		animate( 300, style( { transform: 'translateX(100%)' } ) )
	])
]);


export const foldInOut = trigger( "foldInOut", [

	/*
	state( 'void', style( { transform: "rotateX(90deg)", "transform-origin": "top" } ) ),
	state( '*', style( { transform: "rotateX(0deg)", "transform-origin": "top" } ) ),
	*/
	transition( '* => void', [
		style( { height: '*', transform: "rotateX(0deg)", "transform-origin": "top" } ),
		animate( "300ms ease", style( { height: 0, transform: "rotateX(90deg)", "transform-origin": "top" } ) ) 
	] ),
	transition( 'void => *', [
		style( { height: '0', transform: "rotateX(90deg)", "transform-origin": "top" } ),
		animate( "300ms ease", style( { height: "*", transform: "rotateX(0deg)", "transform-origin": "top" } ) ) 
	] ),

] );

export const accordeonMe = trigger( 'accordeonMe', [
	transition( ':enter', [
		style( { height: '0px', minHeight: '0', opacity: 0 } ),
		animate( '300ms', style( { height: '*', opacity: 1 } ) )
	] ),
	transition( ':leave', [
		style( { height: '*', opacity: 1 } ),
		animate( '280ms', style( { height: '0px', opacity: 0 } ) ) 
	]),
]);
